export default __webpack_public_path__ + "static/media/nhb_logo_colour.ea86be5f.svg";